var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clearfix common-body-box"},[_c('nav-header'),_c('div',[_vm._t("swiper",function(){return [_c('div',{staticClass:"common-swiper-box"})]})],2),_c('div',{staticClass:"common-body-content"},[_c('div',{staticClass:"common-body-content-box"},[_vm._t("default")],2)]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }